export default (opts = {}) => {
    const component = {
        model: {
            defaults: {
              type: 'Secao',
              name: "Seção Conteudos",
              attributes: { class: 'section'  },
              components: [
                {
                  type: 'containerContent1',
                },
      
              ],
              styles: `
             .section{
               position:relative; 
               with:100vw; 
               padding: 75px 5%; 
             }
             *{
              font-family: Roboto, Arial, sans-serif;
            }
            `,
            },
          },
          view: {
      
          },
};
  return component; 
};